const convertToIso = (value) => {
    var day;
    var month;
    var year;

    var result = null;

    if (value) {
        var splitter = ' ';
        if (value.indexOf('/') > 0) {
            splitter = '/';
        }
        else if (value.indexOf('-') > 0) {
            splitter = '-';
        }
        var splitted = value.split(splitter);
            day = splitted[0];
            month = splitted[1];
            year = splitted[2];

            result = new Date(parseInt(year), parseInt(month) - 1, parseInt(day) + 1).toISOString().substring(0, 10);
    }
    
    return result;
}

const parseToDateString = (value) => {
    return value ? new Date(value).toLocaleDateString('en-GB') : null;
}

export { convertToIso, parseToDateString };